var r = Object.defineProperty;
var p = (n, s, t) => s in n ? r(n, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[s] = t;
var e = (n, s, t) => p(n, typeof s != "symbol" ? s + "" : s, t);
import { HttpClient as i, httpClient as o } from "../../httpClient.js";
class a extends i {
  constructor() {
    super(...arguments);
    e(this, "endpoint", "/auth");
  }
  async login(t) {
    return o.post(`${this.endpoint}/login`, t);
  }
  async signup(t) {
    return o.post(`${this.endpoint}/signup`, t);
  }
  async logout() {
    return o.post(`${this.endpoint}/logout`);
  }
  async forgotPassword(t) {
    return o.post(`${this.endpoint}/forgot-password`, t);
  }
  async resetPassword(t) {
    return o.post(`${this.endpoint}/reset-password`, t);
  }
  async refreshToken() {
    return o.post(`${this.endpoint}/refresh`);
  }
}
const h = new a();
export {
  h as default
};
